import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MibIconsModule } from '@medinbox/angular';

@Component({
  selector: 'app-precall-info-step',
  imports: [MibIconsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './precall-info-step.component.html',
})
export class PrecallInfoStepComponent {}
